// ACTIONS
export const FETCH_ACCOUNT_MANAGER = 'company/candidateDetails/accountManager/FETCH_ACCOUNT_MANAGER'
export const FETCH_ACCOUNT_MANAGER_SUCCESS = 'company/candidateDetails/accountManager/FETCH_ACCOUNT_MANAGER_SUCCESS'
export const FETCH_ACCOUNT_MANAGER_ERROR = 'company/candidateDetails/accountManager/FETCH_ACCOUNT_MANAGER_ERROR'

export const RESET_ACCOUNT_MANAGER = 'company/candidateDetails/accountManager/RESET'

export const fetchAccountManager = companyId => ({
  type: FETCH_ACCOUNT_MANAGER,
  meta: {
    companyId,
  },
  payload: {
    fetchingAccountManager: true,
    fetchAccountManagerError: null,
  },
})

export const fetchAccountManagerSuccess = ({ result }) => ({
  type: FETCH_ACCOUNT_MANAGER_SUCCESS,
  payload: {
    profile: result,
    fetchingAccountManager: false,
    lastUpdatedAccountManager: Date.now(),
  },
})

export const fetchAccountManagerError = errorMessage => ({
  type: FETCH_ACCOUNT_MANAGER_ERROR,
  error: true,
  payload: new Error(errorMessage),
})

export const resetAccountManager = () => ({
  type: RESET_ACCOUNT_MANAGER,
})

// DEFAULT STATE
const defaultState = {
  profile: {},
  lastUpdatedAccountManager: null,
  fetchingAccountManager: false,
  fetchAccountManagerError: null,
}

// REDUCERS
const profile = (state = defaultState, { type, payload }) => {
  switch (type) {
    case FETCH_ACCOUNT_MANAGER:
    case FETCH_ACCOUNT_MANAGER_SUCCESS:
      return { ...state, ...payload }

    case FETCH_ACCOUNT_MANAGER_ERROR:
      return {
        ...state,
        fetchingAccountManager: false,
        fetchAccountManagerError: payload,
      }

    case RESET_ACCOUNT_MANAGER:
      return defaultState

    default:
      return state
  }
}

export default profile
